'use client'

import { useState } from 'react'

export function useImageCarousel(product: any, max: number = 5, swipeThreshold: number = 30) {
  const [hoveredImageIndex, setHovered] = useState(0)
  const [loadedIndexes, setLoadedIndexes] = useState<number[]>([0])
  const [touchStartX, setTouchStartX] = useState<number | null>(null)

  const variant = product?.variant
  const [prevVariantId, setPrevVariantId] = useState(variant?.id)
  if (variant?.id !== prevVariantId) {
    setPrevVariantId(variant?.id)
    setHovered(0)
    setLoadedIndexes([0])
  }
  const hasImages: boolean = variant?.images?.length > 0
  const rawImages: string[] = hasImages ? variant.images : ['placeholder.png']
  const allImages: string[] = rawImages.slice(0, max)
  const remainingCount = rawImages.length - max

  // ponytail: an image only gets a src once the user actually reaches it. A 200-product
  // grid was firing 5 requests per card up front. Preload index 1 on hover if the
  // cross-fade ever feels late.
  const setHoveredImageIndex = (index: number) => {
    setHovered(index)
    setLoadedIndexes(prev => prev.includes(index) ? prev : [...prev, index])
  }

  const shouldLoadImage = (index: number) => loadedIndexes.includes(index)

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.touches[0].clientX)
  }

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX === null) return
    const diff = touchStartX - e.changedTouches[0].clientX
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        setHoveredImageIndex((hoveredImageIndex + 1) % allImages.length)
      } else if (diff < 0) {
        setHoveredImageIndex((hoveredImageIndex - 1 + allImages.length) % allImages.length)
      }
    }
    setTouchStartX(null)
  }

  const onMouseEnter = () => { if (allImages.length > 1) setHoveredImageIndex(1) }
  const onMouseLeave = () => setHoveredImageIndex(0)

  return {
    hoveredImageIndex, setHoveredImageIndex,
    allImages, remainingCount, shouldLoadImage, hasImages,
    handleTouchStart, handleTouchEnd,
    onMouseEnter, onMouseLeave,
  }
}
